// @flow

import { type Country } from '@tectonics/prs/country';

const NOT_NUMBERS = /[^0-9]+/ug;

export function getZipcodeNormalizer(country: Country): ?string => string {

  return (zipcode: ?string) => {

    if (!zipcode)
      return '';

    const onlyNumbersZipcode = zipcode.replace(NOT_NUMBERS, '');

    switch(country) {
      case 'br':
        return onlyNumbersZipcode.substr(0, 8);

      case 'mx':
      case 'pe':
      case 'bo':
        return onlyNumbersZipcode.substr(0, 5);

      case 'ar':
        return onlyNumbersZipcode.substr(0, 4);

      case 'co':
      case 'uy':
        return onlyNumbersZipcode.substr(0, 6);

      case 'cl':
      case 'ec':
        return onlyNumbersZipcode.substr(0, 7);

      default:
        throw new Error(`ZipcodeNormalizer: not implemented for country ${country}`);
    }
  };
}
